import { TableCell, TableHeader } from '@design/components/table';
import { isValidElement, ReactNode } from 'react';

import styles from './CustomComponents.module.scss';

/** Recursively extracts a plain-text string from a ReactNode for use in `title` attributes. */
const getTextContent = (node: ReactNode): string => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(getTextContent).join('');
  }
  if (isValidElement(node)) {
    return getTextContent((node.props as { children?: ReactNode }).children);
  }
  return '';
};

export const CustomLink = ({
  href,
  children,
  title,
}: {
  href?: string;
  children?: ReactNode;
  title?: string;
}) => (
  <a
    className={styles.markdownA}
    href={href}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

export const CustomTableCell = ({ children }: { children?: ReactNode }) => (
  <TableCell alignment="left" isNumber={false}>
    <span className={styles.truncatedCell} title={getTextContent(children)}>
      {children}
    </span>
  </TableCell>
);

export const CustomTableHeader = ({ children }: { children?: ReactNode }) => (
  <TableHeader alignment="left">{children}</TableHeader>
);

export const CustomTable = ({ children }: { children?: ReactNode }) => (
  <div className={styles.markdownTableContainer}>
    <table className={styles.markdownTable}>{children}</table>
  </div>
);
